import type { ReactNode } from "react";

import { Box, Icon } from "@mui/material";

import { BodyText, BodyTextSmall } from "~/components/Typographies";

interface EmailProviderRowProps {
	action?: ReactNode;
	icon: string;
	statusColor?: string;
	statusText: string;
	title: string;
}

const EmailProviderRow = ({
	action,
	icon,
	statusColor = "text.secondary",
	statusText,
	title
}: EmailProviderRowProps) => (
	<Box
		sx={{
			alignItems: "center",
			border: 1,
			borderColor: "divider",
			borderRadius: 1,
			display: "flex",
			flexWrap: "wrap",
			gap: 2,
			justifyContent: "space-between",
			p: 1.5
		}}
	>
		<Box sx={{ alignItems: "center", display: "flex", gap: 1.5 }}>
			<Icon sx={{ color: "text.secondary" }}>{icon}</Icon>
			<Box>
				<BodyText bold>{title}</BodyText>
				<BodyTextSmall color={statusColor}>{statusText}</BodyTextSmall>
			</Box>
		</Box>
		{action}
	</Box>
);

export default EmailProviderRow;
